import React from 'react'
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarMenu,
    SidebarLink,
    SidebarRoute,
    SideBtnWrap
} from './SidebarElements'

const Sidebar = ({isOpen, toggle}) => {
    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon/>
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarRoute to='/home' onClick={toggle}>Home</SidebarRoute>
                    <SidebarRoute to='/services' onClick={toggle}>Services</SidebarRoute>
                    <SidebarRoute to='/about' onClick={toggle}>About</SidebarRoute>
                    <SidebarRoute to='/contact' onClick={toggle}>Contact Us</SidebarRoute>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar